"use client"

import Title from "@/components/common/Typography/Title"
import { Col, Row, Skeleton, Tabs } from "antd"

const FlightCommonRoutesSkeleton = () => {
  return (
    <Row style={{ marginBlock: '2rem' }}>
      <Col span={24}>
        <Title
          level={3}
          style={{
            margin: 0,
            marginBottom: '0.5rem'
          }}
        >
          Chặng bay giá tốt
        </Title>
      </Col>
      <Col span={24}>
        <Tabs
          items={
            [
              {
                label: "Chặng bay phổ biến",
                key: "ITIN_ROUTE",
                children: (
                  <Row gutter={[0, 10]}>
                    {[1,2,3,4].map((idx) => {
                      return (
                        <Col span={24} key={idx}>
                          <Skeleton paragraph={false} styles={{ title: { height: '2.3rem', minWidth: '15rem', maxWidth: '30rem', margin: 0 } }} active />
                        </Col>
                      )
                    })}
                  </Row>
                )
              },
              {
                label: "Điểm đến phổ biến",
                key: "DES_ROUTE",
                children: (
                  <Row gutter={[0, 10]}>
                    {[1,2,3,4].map((idx) => {
                      return (
                        <Col span={24} key={idx}>
                          <Skeleton paragraph={false} styles={{ title: { height: '2.3rem', minWidth: '15rem', maxWidth: '30rem', margin: 0 } }} active />
                        </Col>
                      )
                    })}
                  </Row>
                )
              }
            ]}
        />
      </Col>
    </Row>

  )
}

export default FlightCommonRoutesSkeleton